import { httpClient, unwrap, unwrapPaginated } from '@/services/httpClient';
import type {
  AiCommand, AiConversation, AiConversationDetail, AiHistoryListEntry, AiSearchResult,
} from '@/features/ai/types';

export const aiApi = {
  history: (page: number, filters?: { featureKey?: string; userId?: number }) =>
    unwrapPaginated<AiHistoryListEntry>(httpClient.get('/ai/history', { params: { page, per_page: 20, feature_key: filters?.featureKey, user_id: filters?.userId } })),

  conversations: (contextType: string, contextId: number) =>
    unwrap<AiConversation[]>(httpClient.get('/ai/conversations', { params: { context_type: contextType, context_id: contextId } })),
  createConversation: (contextType: string, contextId: number, title?: string) =>
    unwrap<AiConversation>(httpClient.post('/ai/conversations', { context_type: contextType, context_id: contextId, title })),
  getConversation: (id: number) => unwrap<AiConversationDetail>(httpClient.get(`/ai/conversations/${id}`)),
  removeConversation: (id: number) => unwrap<null>(httpClient.delete(`/ai/conversations/${id}`)),
  sendMessage: (conversationId: number, content: string) =>
    unwrap<{ content: string; model: string; tokens_input: number; tokens_output: number; suggestions?: AiCommand[] | null }>(
      httpClient.post(`/ai/conversations/${conversationId}/messages`, { content }),
    ),
  commands: () => unwrap<AiCommand[]>(httpClient.get('/ai/commands')),

  /** Rule-based dashboard insights (SQL, not a language model) — see insights_controller.php. */
  insights: (kind: 'timeline-suggestions' | 'project-summary') =>
    unwrap<{ content: string; model: string }>(httpClient.get(`/ai/insights/${kind}`)),

  search: (query: string) => unwrap<AiSearchResult>(httpClient.post('/ai/search', { query })),
};
